import { Component, OnInit, Input, AfterViewInit, ContentChildren, ContentChild, Inject, OnChanges, SimpleChange, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ElementRef, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';


export interface INews {
  title: string;
  photo: { src: string, alt: string };
  url: string;
  field_content_category: string;
  field_publish_date: Date;
}

@Component({
  selector: 'app-news-panel',
  templateUrl: './news-panel.component.html',
  styleUrls: ['./news-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsPanelComponent implements OnInit, OnChanges {
  /**
   * Slide configuration.
   * http://kenwheeler.github.io/slick/
   */
  slideConfig;
  /**
   * Input of news for iteration over with slick carousel
   *
   * @type {Array<INews>}
   * @memberof NewsPanelComponent
   */
  @Input()
  news: Array<INews>;

  /**
   * Title of the panel
   *
   * @type {string}
   * @memberof NewsPanelComponent
   */
  @Input()
  title: string;

  @Input()
  field_content_category: string;

  /**
   * Content child for select the first button, click on that and center the slider.
   *
   * @type {ElementRef}
   * @memberof NewsPanelComponent
   */
  @ContentChild('#slick-slide-control00', {static:false}) button: ElementRef;
  constructor(@Inject(DOCUMENT) private document:Document) {

  }

  ngOnInit(): void {

    this.slideConfig = {
      mobileFirst: true,
      autoplay: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      initialSlide: 0,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="true"><svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg"><g transform="rotate(-180 4.996999740600587,7.998499870300293) " id="svg_1"><path d="m0.07,1.335l1.418,-1.34l8.51,8.038l-1.418,1.341l-8.51,-8.039z" fill="currentColor"/><path d="m1.413,16.002l-1.417,-1.34l8.51,-8.038l1.418,1.34l-8.511,8.038z" fill="currentColor"/></g></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="true"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16"><path fill="currentColor" d="M.07 1.335l1.418-1.34 8.51 8.038L8.58 9.374z"/><path fill="currentColor" d="M1.413 16.002l-1.417-1.34 8.51-8.038 1.418 1.34z"/></svg></button>',
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    }
  }

  ngOnChanges(changes:SimpleChanges){
  }

  get newsFilter() {
    // tslint:disable-next-line:max-line-length
    return this.news ? Array.from(this.news.reduce((a, b) => a.set(b.title, b), new Map()).values()).filter(value => value.photo !== '' as any).splice(0, 15) : [];
  }

}
